import { loadTemplate } from "utils/load_template"
import SelectRefinementWidget from 'components/algolia/select_refinement_widget'
import DistinctRefinementWidget from 'components/algolia/distinct_refinement_widget'

export function jurisdictionsWidget({ showCounters }) {
  return new DistinctRefinementWidget({
    connector: instantsearch.connectors.connectRefinementList,
    showCounters: showCounters,
    facetCounterAttribute: "jurisdictions_credit_types",
    facetCounterComparisonFn: (jurisdictions_credit_types, facetValue, facetFilters) => {
      // If this course is outdated in Algolia we return false
      if (jurisdictions_credit_types !== null && jurisdictions_credit_types !== undefined) {
        const creditTypesFilters = facetFilters.flat().filter((item) => item.match(/credit_types:/)).map((item) => item.split(":")[1])
        const jurisdictionKey = facetValue.replaceAll(" ", "")

        // If user selected one or more credit types we count the jurisdictions which have those credit types
        if (creditTypesFilters.length > 0) {
          let matches = 0

          creditTypesFilters.forEach(element => {
            matches += (jurisdictions_credit_types[jurisdictionKey] || []).indexOf(element) >= 0 ? 1 : 0
          })

          return matches > 0
        } else {
          return Object.keys(jurisdictions_credit_types).indexOf(jurisdictionKey) >= 0
        }
      } else {
        return false
      }
    }
  }).widget({
    attribute: "jurisdictions",
    operator: "or",
    limit: 500,
    container: "jurisdictions",
    templates: {
      item: loadTemplate(showCounters ? "cle_jurisdictions_filter_template_with_counters" : "cle_jurisdictions_filter_template")
    },
    cssClasses: {
      root: "scrollable"
    },
    sortBy: ["name:asc"]
  })
}

export function jurisdictionsMobileWidget() {
  return new SelectRefinementWidget({ selectType: "multiple" }).widget({
    attribute: "jurisdictions",
    container: "jurisdictions_mobile",
    limit: 500,
    sortBy: ["name:asc"]
  })
}
